<!--
  Confirm Dialog
  알림 팝업
  확인, 취소/확인, 닫기/아니오/적용 등의 알림 팝업

  @since 2018-03-16
  @author kdydesign.kim
-->

<template>
  <q-dialog ref="confirmDialog"
            stack-buttons
            :prevent-close="preventClose"
            @hide="onHide"
            @show="onShow"
            :noBackdropDismiss="true"
            class="bs bs-q-dialog bs-q-dialog-default">

    <div slot="header">
      <slot></slot>
    </div>

    <div slot="body">
      <div class="dialog-body-group">
        <div class="contents-row">
          <slot></slot>

          <p v-if="code === 'newLine'"
             v-for="text in message"
             :style="`text-align: ${textAlign}`">
            {{text}}
          </p>

          <p v-if="code === 'ok'"
             :style="`text-align: ${textAlign}`">{{ message }}</p>
        </div>
      </div>
    </div>

    <template slot="buttons"
              slot-scope="props">
      <q-toolbar slot="footer">
        <div class="contents-row">
          <div class="footer-option-group">
            <div class="row bs-q-btn-dialog-group">
              <q-btn v-for="btn in footerBtnList"
                     :ha-force="haForce"
                     :key="btn.type"
                     :label="btn.text"
                     :color="btn.color"
                     :auth-force="btn.authForce"
                     :class="classStyle(btn.color)"
                     :outline="outlineStyle(btn.color)"
                     @click="onFooterEvent(btn.type)"></q-btn>
            </div>
          </div>
        </div>
      </q-toolbar>
    </template>
  </q-dialog>
</template>

<script>
  export default {
    name: 'ConfirmDialog',
    props: {
      preventClose: {
        type: Boolean,
        default: false
      },
      footerBtnList: {
        type: Array,
        default: () => [
          // text: btn text, color: primary(확인 및 적용) dark(취소 등 일반 버튼), type: 버튼 타입
          {
            text: '',
            color: 'primary',
            type: 'confirm'
          }
        ]
      },
      haForce: {
        type: Boolean,
        default: false
      },
      textAlign: {
        type: String,
        default: () => 'center'
      }
    },
    data () {
      return {
        message: '',
        code: void 0
      }
    },
    methods: {
      classStyle (type) {
        let baseClass = ['bs', 'bs-q-btn-dialog']
        let confirmClass = ['bs-q-btn-dialog-primary']
        let cancelClass = ['bs-q-btn-dialog-line']
        let rstClass = []

        switch (type) {
          case 'primary' :
            rstClass = _.concat(baseClass, confirmClass)
            break
          case 'dark' :
            rstClass = _.concat(baseClass, cancelClass)
            break
          default :
            rstClass = _.concat(baseClass, confirmClass)
        }

        let endCommClass = []
        let num = 12 / this.footerBtnList.length
        num = parseInt(num)
        endCommClass = ['col-xs-' + num, 'col-sm-' + num, 'col-md-' + num]

        return _.concat(rstClass, endCommClass)
      },
      outlineStyle (type) {
        return type !== 'primary'
      },
      onHide () {
        this.$emit('hide')
      },
      onShow () {
        this.$emit('show')
      },
      onFooterEvent (btn) {
        this.$emit(`on${_.upperFirst(btn)}`)
        this.hide()
      },
      show (message) {
        if (message !== undefined) {
          if (message.includes('<br>')) {
            this.message = message.split('<br>')
            this.code = 'newLine'
          } else if (message.includes('\n')) {
            this.message = message.split('\n')
            this.code = 'newLine'
          } else {
            this.message = message
            this.code = 'ok'
          }
        }

        this.$nextTick(() => {
          this.$refs.confirmDialog.show()
        })
      },
      hide () {
        this.$refs.confirmDialog.hide()
      }
    }
  }
</script>
